// The data is wrapped in a nested class so we can replicate it without running into a circular reference when
// converting it to a JSON object that gets passed to the update API.
export class AppraisalData {
  bedsCurrent = 0;

  bedsCurrentInt = 0;

  beds_potential = 0;

  beds_potential_int = 0;

  beds_future = 0;

  beds_future_int = 0;

  noiCurrent = 0;

  noiCurrentInt = 0;

  noi_potential = 0;

  noi_potential_int = 0;

  noi_future = 0;

  noi_future_int = 0;

  noi_multiple_current = 0;

  noi_multiple_current_int = 0;

  noi_multiple_potential = 0;

  noi_multiple_potential_int = 0;

  noi_multiple_future = 0;

  noi_multiple_future_int = 0;

  square_foot_current = 0;

  square_foot_current_int = 0;

  square_foot_potential = 0;

  square_foot_potential_int = 0;

  square_foot_future = 0;

  square_foot_future_int = 0;

  price_square_foot_current = '';

  price_square_foot_current_int = '';

  price_square_foot_potential = '';

  price_square_foot_potential_int = '';

  price_square_foot_future = '';

  price_square_foot_future_int = '';

  monthly_rental_current = '';

  monthly_rental_current_int = '';

  monthly_rental_potential = '';

  monthly_rental_potential_int = '';

  monthly_rental_future = '';

  monthly_rental_future_int = '';

  capitalization_current = 0;

  capitalization_current_int = 0;

  capitalization_potential = 0;

  capitalization_potential_int = 0;

  capitalization_future = 0;

  capitalization_future_int = 0;

  currentValuationYear = 0;

  currentValuationYearInt = 0;

  potential_valuation_year = 0;

  potential_valuation_year_int = 0;

  future_valuation_year = 0;

  future_valuation_year_int = 0;

  annualInflationRateFuture = 0;

  annualInflationRateFutureInt = 0;

  resident_real_estate_value_current = 0;

  resident_real_estate_value_potential = 0;

  resident_real_estate_value_future = 0;

  commercial_real_estate_value_current = 0;

  commercial_real_estate_value_potential = 0;

  commercial_real_estate_value_future = 0;

  ral_real_estate_value_current = 0;

  ral_real_estate_value_potential = 0;

  ral_real_estate_value_future = 0;

  ral_business_value_current = 0;

  ral_business_value_potential = 0;

  ral_business_value_future = 0;

  ral_enterprise_appraisal_current = 0;

  ral_enterprise_appraisal_potential = 0;

  ral_enterprise_appraisal_future = 0;

  price_per_bed_business_real_estate_current = 0;

  price_per_bed_business_real_estate_potential = 0;

  price_per_bed_business_real_estate_future = 0;

  price_per_bed_business_potential_current = 0;

  price_per_bed_business_potential_future = 0;

  ral_enterprise_apprisal_potential_current = 0;

  ral_enterprise_apprisal_potential_future = 0;

  ral_real_estate_value_potential_current = 0;

  ral_real_estate_value_potential_future = 0;

  ral_enterprise_business_value_potential_current = 0;

  ral_enterprise_business_value_potential_future = 0;

  price_per_bed_current = 0;

  price_per_bed_potential = 0;

  price_per_bed_future = 0;

  capitalization_rate_current = 0;

  capitalization_rate_potential = 0;

  capitalization_rate_future = 0;
}



// WEBPACK FOOTER //
// ./src/app/enterpriseappraisal/appraisalData.ts